export * from './reqdetcriteria.component';
